import React from 'react';
import { Plugin, Template, TemplatePlaceholder } from '@devexpress/dx-react-core';
import { useTranslation } from 'react-i18next';
import { SEARCH_RESULTS } from '../../../i18n/keyConstants';

const TableHeaderCovering = ({ tableSize, children }) => {
    const buttons = children[0];
    const occupancyFilter = children[1];
    const descriptionFilters = children[2];
    const weekPickers = children[3];
    const { t } = useTranslation();
    return (
        <Plugin>
            <Template name='header'>
                <div className='card-header py-2 d-flex position-relative dx-g-bs4-toolbar'>
                    <div className='tableSize padding-top-10px padding-bottom-10px c-black'>
                        <span>{t(SEARCH_RESULTS)} {tableSize}</span>
                    </div>
                    <div className='d-flex ml-auto my-auto'>{buttons}</div>
                </div>
                <div className='d-lg-none card-header pt-1 pb-2 c-black position-relative d-flex justify-content-left align-content-center'>
                    <div className='d-flex flex-column'>
                        <div className='padding-top-10px pb-1 c-black'>{occupancyFilter}</div>
                        <div className='padding-bottom-10px c-black' style={{ maxWidth: '195px' }}>
                            {descriptionFilters}
                        </div>
                    </div>
                </div>
                <div className='card-header pt-1 pb-2 d-flex'>
                    <div className='d-none d-lg-flex mr-auto flex-row'>
                        {occupancyFilter}
                        {descriptionFilters}
                    </div>
                    <div className='d-lg-none ml-auto mr-auto'>{weekPickers}</div>
                    <div className='d-none d-lg-block ml-auto'>{weekPickers}</div>
                </div>
                <TemplatePlaceholder />
            </Template>
        </Plugin>
    );
};

export default TableHeaderCovering;
